var _script, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSolflare = function SvgSolflare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 50 50",
    fill: "none"
  }, props), _script || (_script = /*#__PURE__*/React.createElement("script", {
    type: "text/javascript"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.17 47.91c.526 0 .951.421.951.94 0 .52-.425.94-.95.94a.946.946 0 0 1-.95-.94c0-.519.425-.94.95-.94ZM24.139 2.995a.99.99 0 0 1 .903.847l1.13 8.215c.38 2.715 3.654 3.89 5.675 2.046L43.175 3.792a.679.679 0 0 1 .95.038c.231.248.238.627.017.883l-9.88 11.396c-1.818 2.094-.476 5.364 2.296 5.597l8.717.84a.783.783 0 0 1 .71.853.784.784 0 0 1-.664.695l-9.159 1.43c-2.66.363-3.864 3.512-2.134 5.558l3.22 3.796a.716.716 0 0 1-.09 1.018.738.738 0 0 1-.915.02l-3.969-2.998c-2.142-1.61-5.23-.241-5.456 2.425l-.875 10.397a.787.787 0 0 1-.852.713.786.786 0 0 1-.717-.672l-1.387-10.044c-.372-2.714-3.646-3.89-5.675-2.046L5.26 44.665a.62.62 0 0 1-.868-.035.601.601 0 0 1-.015-.806l10.519-12.138c1.818-2.094.484-5.364-2.288-5.598l-8.719-.84a.783.783 0 0 1-.71-.853.785.785 0 0 1 .664-.695l9.153-1.43c2.66-.362 3.872-3.511 2.142-5.557l-2.192-2.584a.888.888 0 0 1 .113-1.262.915.915 0 0 1 1.133-.025l2.692 2.034c2.142 1.611 5.23.242 5.456-2.424l.724-8.56a.991.991 0 0 1 1.074-.897ZM.951 23.435c.525 0 .95.42.95.94 0 .519-.425.94-.95.94a.946.946 0 0 1-.951-.94c0-.52.426-.94.95-.94Zm47.68-.955c.524 0 .95.42.95.94s-.426.94-.95.94a.946.946 0 0 1-.951-.94c0-.52.425-.94.95-.94ZM24 0c.525 0 .95.421.95.94 0 .52-.425.94-.95.94a.945.945 0 0 1-.95-.94c0-.519.425-.94.95-.94Z",
    fill: "url(#solflare_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.571 32.78c4.96 0 8.98-3.977 8.98-8.883 0-4.905-4.02-8.882-8.98-8.882-4.96 0-8.98 3.977-8.98 8.882 0 4.906 4.02 8.882 8.98 8.882Z",
    fill: "url(#solflare_svg__b)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "solflare_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(4.99219 12.06388 -12.18114 5.04071 22.52 20.618)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC10B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB3F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "solflare_svg__a",
    x1: 6.478,
    y1: 7.92,
    x2: 34.911,
    y2: 33.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC10B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB3F2E"
  })))));
};
export default SvgSolflare;